import React, { useEffect } from "react";
import { set, useForm } from "react-hook-form";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { AppContext } from "../../contexts/AppContext";
import BackButton from "../Buttons/BackButton";
import FieldError from "../FieldError";
import { useNavigate } from "react-router-dom";
import { updateApplication } from "../../Services/applicationService";
import Loader from "../Loader/Loader";
import NoDocId from "../Popups/NoDocId";

type FormData = {
  photoId: string;
};

const PhotoID = ({ handleNext, handleCancel, handleBack }) => {
  const { appState, userFlows, setAppState, setUserFlows } =
    React.useContext(AppContext);
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [isAdult, setIsAdult] = React.useState(false);
  const [displayedOptions, setDisplayedOptions] = React.useState<string[]>([]);
  const [showEndPopup, setShowEndPopup] = React.useState(false);

  const onClosePopup = () => {
    setShowEndPopup(false);
  };
  const options = [
    "NZ passport",
    "overseas passport",
    "refugee travel document",
    "certificate of identity",
    "current NZ driver licence",
    "current NZ firearms licence",
    "Kiwi Access Card (issued after April 2022)",
    "I do not have any of these photo IDs",
  ];

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid },
  } = useForm<FormData>({ mode: "onTouched" });

  const selectedPhotoId = watch("photoId");

  useEffect(() => {
    setLoading(true);
    const applicationTypeId = appState?.requestPayload?.applicationTypeId;
    setIsAdult(applicationTypeId === "dee0075c-6dcd-ef11-b8e9-00224891c497");
    setDisplayedOptions(
      applicationTypeId === "dee0075c-6dcd-ef11-b8e9-00224891c497"
        ? options
        : [...options.slice(0, 4), options[options.length - 1]]
    );
    setLoading(false);  // stops it to prevent running indefinitely (207715)
  }, [appState?.requestPayload?.applicationTypeId]);

  const onSubmit = (data: FormData) => {
    if (
      userFlows.refereeNotAvailable &&
      data.photoId === "I do not have any of these photo IDs"
    ) {
      setShowEndPopup(true);
      return;
    }

    console.log("Selected photo ID:", data.photoId);
    setLoading(true);
    const updatedAppState = {
      ...appState,
      requestPayload: {
        ...appState.requestPayload,
        photoShop: 
          data.photoId === "I do not have any of these photo IDs"
        ? { flag: false }
        : { flag: true },

      },
    };
    setAppState(updatedAppState);
    updateApplication(updatedAppState.requestPayload)
      .then(() => {
        setLoading(false);
        if (data.photoId === "I do not have any of these photo IDs") {
          //if (!!userFlows.showRefree) handleNext();
          setUserFlows((prev: any) => ({
            ...prev,
            showRefree: prev.isRenew ? false : true,
            showPartnerStore: true,
            noPhotoId: true,
          }));

          navigate("/app/pre-referee");
          return;
        }
        // if (userFlows.showRefree && !userFlows.refereeNotAvailable) {
        //   navigate("/app/pre-referee");
        //   return;
        // }

        handleNext(); // or pass data as needed
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {showEndPopup && <NoDocId onClose={onClosePopup} />}
      {loading && <Loader />}
      <div className="intro">
        <h1 className="intro-title-mi" lang="mi-NZ">
          Whakatūturutia te pono o tāu e kī nei ko wai koe
        </h1>
        <hr />
        <h1 className="intro-title">Prove you are who you say you are</h1>

        <div className="step-container">
          <p className="mb-4">
            You'll need to finish your application at a RealMe partner store and
            provide proof of who you are.
          </p>
          <p className="mb-4">
            If you do not have any of the following photo ID, you'll need to
            provide an identity referee.
          </p>
          <div className="spacer-64" />
          <h2 className="step-title mb-2">
            Select one photo ID you can provide:
          </h2>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="radio-group">
              {displayedOptions.map((label, idx) => (
                <div key={idx} className="radio-option">
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      marginBottom: "0.75rem",
                    }}
                  >
                    <input
                      type="radio"
                      value={label}
                      {...register("photoId", {
                        required: "Please select a photo ID",
                      })}
                      style={{ width: "18px", height: "18px" }}
                    />
                    {label}
                  </label>
                </div>
              ))}
              {errors.photoId && (
                <p className="error-field">{errors.photoId.message}</p>
              )}
            </div>
            {selectedPhotoId === "I do not have any of these photo IDs" && (
              <FieldError
                error={null}
                info="You need to provide an identity referee. Select 'Continue' to enter their details."
              />
            )}

            {/* --------- Buttons --------- */}
            <div className="spacer-64" />

            <div className="step-button-container">
              <SubmitButton
                text={"Continue"}
                type="submit"
                disabled={!isValid}
                onClick={() => {}}
              />
              <BackButton text={"Back"} onClick={handleBack} />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PhotoID;
